<template>
  <div class="sb_footer">
    <Wrapper class="sb_footer_wrapper">
      <div class="sb_footer_options">
        <button
          class="sb_footer_option"
          :class="{ s_active: active === 'background' }"
          @click="$emit('update:active', active === 'background' ? null : 'background')"
        >
          <SvgIcon class="sb_footer_option_icon v_background" icon="background" />
          1. Afbeelding
        </button>
        <button
          class="sb_footer_option"
          :class="{ s_active: active === 'text' }"
          @click="$emit('update:active', active === 'text' ? null : 'text')"
        >
          <SvgIcon class="sb_footer_option_icon" icon="text" />
          2. Tekst
        </button>
        <button
          class="sb_footer_option"
          :class="{ s_active: active === 'image' }"
          @click="$emit('update:active', active === 'image' ? null : 'image')"
        >
          <span class="sb_footer_option_icon">
            <!-- <span
              v-if="images.length"
              class="sb_footer_option_counter"
              :class="{ s_error: images.length > IMAGES_MAX_COUNT }"
              >{{ images.length }}</span
            > -->
            <SvgIcon icon="image" />
          </span>
          3. Logo
        </button>
      </div>
    </Wrapper>
    <Wrapper class="sb_footer_bar">
      <Tools class="sb_footer_bar_tools" :setToolbar="setToolbar" />
      <transition name="fade">
        <div class="sb_footer_bar_order" v-if="price">
          <span class="sb_footer_bar_order_price">
            <span class="sb_footer_bar_order_price_total">Totaal: </span>
            €{{ price }}
          </span>
          <Button class="sb_footer_bar_order_now" :disabled="loading || saving" @click.native="checkDesign">
            <template #content>Bestellen</template>
            <template #icon-right>
              <transition name="fade" mode="out-in">
                <SvgIcon v-if="!saving" class="sb_footer_bar_order_now_icon" icon="arrow-right" />
                <Spinner v-else class="sb_footer_bar_order_now_loader" />
              </transition>
            </template>
          </Button>
        </div>
      </transition>
    </Wrapper>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Tools from './Tools.vue';

export default {
  components: {
    Tools,
  },
  computed: {
    ...mapState('design', ['design', 'images', 'price', 'background']),
    ...mapState('canvas', { canvasManager: 'manager' }),
  },
  props: {
    active: {
      type: String,
      default: null,
    },
    loading: {
      type: [String, Boolean],
      default: false,
    },
    setToolbar: { type: Function },
  },
  methods: {
    ...mapMutations('modal', ['setModalData']),
    checkDesign() {
      if (this.design.dimensions.dpi < 30) {
        this.setModalData({
          title: 'Let op: de kwaliteit is laag',
          content: `We adviseren een andere foto te gebruiken of om een kleinere afmeting te kiezen voor een mooier resultaat. Onder de 30 DPI kan de print namelijk onscherp worden.`,
          callback: this.save,
          button: 'Doorgaan met bestellen',
          cancelButton: 'Ontwerp aanpassen',
        });

        return;
      }

      this.save();
    },
    async save() {
      try {
        this.saving = true;
        const result = await this.$store.dispatch('design/save');
        //location.href = `${location.origin}${location.pathname}?design=${result.id}`;
        // window.open(`https://backend.cfw.staging.breuk.dev/designs/${result.id}.thumbnail.png`, '_blank').focus();
        if (this.$root.orderCallback) {
          result.price = this.price;
          result.backgroundId = this.background;
          window[this.$root.orderCallback](result);
        }
      } catch (error) {
        console.error(error);
        alert(error.message);
      }
      this.saving = false;
    },
  },
  data() {
    return {
      selectedObject: null,
      saving: null,
      IMAGES_MAX_COUNT: this.$root.imagesMaxCount,
    };
  },
  mounted() {
    window.addEventListener('selection:cleared', () => {
      this.selectedObject = null;
    });
  },
};
</script>

<style lang="scss">
#sb_fotowand-designer {
  .sb_footer {
    flex-shrink: 0;
    margin: 0;
    position: relative;
    background: $brand-white;
    border-top: 4px solid $brand-lightest-gray;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    align-items: center;
    @include media('>=medium-portrait') {
      flex-direction: row;
      z-index: 0;
    }
    &_wrapper {
      width: 100%;
    }
    &_options {
      display: flex;
      height: 4rem;
      min-width: 100%;
      @include media('>=small') {
        height: 5rem;
      }
      @include media('>=medium-portrait') {
        height: 6rem;
        min-width: 60%;
        padding-right: 1rem;
      }
      @include media('>=medium') {
        height: 6.5rem;
        max-width: 27rem;
      }
    }
    &_option {
      background: none;
      border: none;
      height: 100%;
      width: 100%;
      color: $brand-primary;
      font-size: 0.6rem;
      text-transform: uppercase;
      font-family: InterGX, Inter, sans-serif;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-weight: 500;
      transition: color 0.4s, background 0.4s;
      padding: 0.8rem 0;
      position: relative;
      &:hover {
        cursor: pointer;
      }
      &_counter {
        position: absolute;
        top: 50%;
        left: -0.4rem;
        transform: translate(-100%, -50%);
        width: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 1rem;
        font-size: 0.6rem;
        background: $brand-secondary;
        color: $brand-white;
        border-radius: 100%;
        transition: background 0.4s;
        &.s_error {
          background: $brand-red;
        }
      }
      &_icon {
        position: relative;
        font-size: 1.5rem;
        margin-bottom: 0.4rem;
        &.v_background {
          font-size: 1.9rem;
          margin-bottom: 0;
          transform: translateY(-0.2rem);
        }
        @include media('>=medium') {
          font-size: 2rem;
          margin-bottom: 0.9rem;
          &.v_background {
            font-size: 2.5rem;
            margin-bottom: 0.45rem;
          }
        }
      }
      &:before {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        transform: scaleY(0.6);
        height: 100%;
        background: $brand-lightest-gray;
        width: 3px;
        transition: transform 0.4s;
        z-index: -1;
      }
      &:last-of-type:before {
        display: none;
      }
      &.s_active {
        background: $brand-primary;
        color: $brand-white;
        &:before {
          transform: scaleY(1);
        }
      }
      &:hover:not(.s_active) {
        background: $brand-primary-light;
        color: $brand-white;
        &:before {
          transform: scaleY(1);
        }
      }
      @include media('>=small') {
        font-size: 0.7rem;
      }
      @include media('>=medium-portrait') {
        padding: 1rem 0;
        &:last-of-type:before {
          display: block;
        }
      }
      @include media('>=medium') {
        font-size: 0.8rem;
      }
    }
    &_bar {
      order: -1;
      height: 4rem;
      display: flex;
      align-items: center;
      border-bottom: 3px solid $brand-lightest-gray;
      width: 100%;
      @include media('>=medium-portrait') {
        order: 0;
        border: none;
      }
      @include media('<=small') {
        height: 7rem;
        flex-direction: column;
        padding-bottom: 0.6rem !important;
      }
      &_tools {
        display: flex;
        justify-content: flex-start;
        flex-grow: 1;
        @include media('>=medium-portrait') {
          position: absolute;
          bottom: 100%;
          left: 0;
          transform: translate(1rem, -1rem);
          height: auto;
        }
        @include media('>=medium') {
          transform: translate(2rem, -1rem);
        }
        @include media('<=small') {
          width: 100%;
          justify-content: flex-start;
          margin-bottom: 0.6rem;
          border-bottom: 2px solid $brand-lightest-gray;
        }
      }
      &_order {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        @include media('<=small') {
          width: 100%;
        }
        &_price {
          color: $brand-white;
          font-size: 1rem;
          font-weight: 600;
          line-height: 1.2;
          max-width: 100%;
          color: $brand-primary;
          text-align: right;
          padding-left: 0.6rem;
          &_total {
            display: none;
          }
          @include media('>=medium-portrait') {
            &_total {
              display: inline;
            }
          }
          @include media('>=medium') {
            font-size: 1.25rem;
          }
          @include media('>=large') {
            font-size: 1.4rem;
          }
        }
        &_now {
          margin-left: 0.6rem;
          text-transform: uppercase;
          &_loader {
            font-size: 1.2rem;
          }
          @include media('<=small') {
            margin-left: 1rem;
          }
          @include media('>=medium') {
            font-size: 1rem;
            padding: 0 1rem;
          }
        }
        @include media('>=medium-portrait') {
          height: 4rem;
          padding: 0.7rem 0 0.7rem 0.8rem;
          background: none;
          border: none;
          flex: 1;
          z-index: 0;
          position: static;
        }
        @include media('>=medium') {
          height: 4.5rem;
        }
      }
    }
  }
}
</style>
